import React from 'react'
import { useFilterStore } from '../../state/filterStore'
import * as UI from '@brewlogix/blx-ui'
import classNames from 'classnames'
import { BrewTypes } from 'src/types/schema/graphql'
import { parseEnumLabel } from 'src/util/helpers'

const BrewTypesFilter: React.FC = () => {
    const {
        brewTypeOptions,
        setBrewTypeOptions,
        toggleBrewArrowUp,
        setToggleBrewArrowUp,
        showAllFilters,
        setNextResultsOffset,
        setPage,
    } = useFilterStore()

    const brewTypes = [BrewTypes.Beer, BrewTypes.Kombucha, BrewTypes.Cider].map((item) => ({
        label: parseEnumLabel(item),
        value: item,
    }))

    const parseIconBrewTypes = (item: string) => {
        if (item === 'Gluten_Free') {
            return 'GlutenFree'
        } else if (item === 'Non__Alcoholic') {
            return 'NonAlcoholic'
        } else {
            return item
        }
    }

    const handleFilterSelection = (item: BrewTypes) => {
        setNextResultsOffset(null)
        setPage(1)
        if (brewTypeOptions?.length) {
            if (!brewTypeOptions?.includes(item)) {
                setBrewTypeOptions([...brewTypeOptions, item])
            } else {
                setBrewTypeOptions(brewTypeOptions?.filter((brew) => brew !== item))
            }
        } else {
            setBrewTypeOptions([item])
        }
    }

    return (
        <div className={classNames('mb-4 flex flex-col items-start justify-start space-y-2')}>
            <UI.Button
                label='Brews'
                data-cy='filterBrews'
                theme='link'
                customClasses='flex flex-row-reverse justify-start text-dark pl-0 pb-0'
                onClick={() => setToggleBrewArrowUp(!toggleBrewArrowUp)}
                size='sm'
            >
                <UI.Icon
                    slug='HeroIcons.ChevronRight'
                    size='sm'
                    customClasses={classNames(
                        toggleBrewArrowUp ? '-rotate-90' : '',
                        'text-gray-300 mr-2 pointer-events-none'
                    )}
                />
            </UI.Button>
            {brewTypeOptions && toggleBrewArrowUp && brewTypeOptions.length > 0 ? (
                <div className='flex w-full flex-col'>
                    <UI.Button
                        theme='link'
                        customClasses='pl-0 text-sm flex items-center font-thin '
                        size='sm'
                        onClick={() => setBrewTypeOptions([])}
                    >
                        <UI.Icon
                            slug='HeroIconsSolid.XCircle'
                            theme='link'
                            customClasses='mr-2'
                            size='sm'
                        />
                        Clear
                    </UI.Button>
                </div>
            ) : (
                ''
            )}
            <div
                className={classNames(
                    !toggleBrewArrowUp ? 'hidden' : '',
                    'grid w-full grid-cols-2 flex-wrap gap-2 overflow-hidden pl-1 pt-2',
                    showAllFilters?.brewTypes ? 'h-auto' : 'max-h-[10.8rem]'
                )}
            >
                {brewTypes.map((item) => (
                    <div
                        key={`filterOption-${item.label}`}
                        className='flex flex-col overflow-hidden'
                    >
                        <UI.Button
                            theme='link'
                            id={`filterBrew-${item.label}`}
                            customClasses={classNames(
                                'p-3 brew-filter border-r-1  flex flex-col h-auto',
                                brewTypeOptions?.includes(item?.value)
                                    ? 'border-dark bg-gray-50'
                                    : 'border-gray-100'
                            )}
                            onClick={() => handleFilterSelection(item?.value)}
                        >
                            <UI.Icon
                                slug={parseIconBrewTypes(item.value)}
                                size='md'
                                customClasses='mb-2'
                            />
                            <p className='text-sm font-normal text-dark'>{item.label}</p>
                        </UI.Button>
                    </div>
                ))}
            </div>
            {/* Leaving this here for now so it can be used when we add in more filterable options */}
            {/* {toggleBrewArrowUp && (
                <div className='flex flex-col w-full'>
                    <UI.Button
                        theme='link'
                        customClasses='pl-1 text-sm flex items-center font-thin'
                        size='sm'
                        onClick={() =>
                            setShowAllFilters({
                                ...showAllFilters,
                                brewTypeOptionss: !showAllFilters.brewTypeOptionss,
                            })
                        }
                    >
                        {showAllFilters?.brewTypeOptionss ? 'Show Less' : 'Show More'}
                        <UI.Icon
                            slug='HeroIconsSolid.ChevronDown'
                            theme='link'
                            customClasses={classNames(
                                'ml-2 text-gray-300',
                                showAllFilters?.brewTypeOptionss ? '-rotate-180' : ''
                            )}
                            size='sm'
                        />
                    </UI.Button>
                </div>
            )} */}
        </div>
    )
}

export default BrewTypesFilter
